import { render, staticRenderFns } from "./FloristRequests.vue?vue&type=template&id=6d628bc0"
import script from "./FloristRequests.vue?vue&type=script&lang=js"
export * from "./FloristRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports